import {RestApiService} from '../../../../rest-api.service';
import {ApiV0} from '../../../api.v0';
import {ApiV0AccountCalendarIntegration} from './api.v0.crm.integrations.calendar';
import {ApiV0Accounts} from '../api.v0.accounts';

export class ApiV0AccountIntegrations {

    segment: string;

    constructor(v0: ApiV0Accounts, api: RestApiService) {
        this.segment = v0.segment + '/integrations';
        this.calendar = new ApiV0AccountCalendarIntegration(this, api);
    }

    public readonly calendar: ApiV0AccountCalendarIntegration;
}
